module.exports = __webpack_public_path__ + "img/fcu2.b5e93734.jpg";